import { render } from "./top-height-methods-load-page.vue?vue&type=template&id=529f6830"
import script from "./top-height-methods-load-page.vue?vue&type=script&lang=ts"
export * from "./top-height-methods-load-page.vue?vue&type=script&lang=ts"

import "./top-height-methods-load-page.vue?vue&type=style&index=0&id=529f6830&lang=less"
script.render = render

export default script